var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Regras fiscais","p-read-link":"fiscalRules.read.one","p-create-link":"fiscalRules.create","p-name":"fiscalRules"}})}
var staticRenderFns = []

export { render, staticRenderFns }